import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-change-status-dialog',
  templateUrl: './change-status-dialog.component.html',
  styleUrls: ['./change-status-dialog.component.scss']
})
export class ChangeStatusDialogComponent {
  @Input() selectedUser: number[] = []
  @Input() userName: string | undefined
  @Input() userId: number | undefined
  @Input() groupStatus: string | 'blocked' | 'unlocked' | 'none' = 'none'
  @Input() userStatus!: boolean

  @Output() changeStatusEvent: EventEmitter<string> = new EventEmitter<string>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  changeStatusUser() {
    let userIds: string
    if (this.selectedUser.length === 0 && this.userId) {
      userIds = this.userId.toString()
    } else {
      userIds = this.selectedUser.join(',')
    }
    this.changeStatusEvent.emit(userIds)
  }
}
